<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<p class="h2"><span class="bold">List of Genealogical Tables</span></p>
<p class="fig"><span class="f_fig">I.</span> The Family of Antipater</p>
<p class="fig"><span class="f_fig">II.</span> The Family of Antipater’s Eldest Daughter</p>
<p class="fig"><span class="f_fig">III.</span> The Family of Nikaia</p>
<p class="fig"><span class="f_fig">IV.</span> The Families of Eurydike and Berenike</p>
<p class="fig"><span class="f_fig">V.</span> The Families of Phila</p>
<p class="fig"><span class="f_fig">VI.</span> The Macedonian Kings, 359–239</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_table.vue?02c52f30